<template>
    <div class="business">
        <Header ref="header" :title="title" @backPage="onBack"></Header>
        <div class="content">
            <dl class="uploadtips" v-show="step===1">
                <dt>上传本人身份证照片</dt>
                <dd>1、请上传本人的身份证照片（最新的，彩色的）</dd>
                <dd>2、拍照是请确保身份证边框完整，图像清晰，光线均匀</dd>
            </dl>
            <dl class="uploadtips" v-show="step===2">
                <dt>上传企业营业照片</dt>
                <dd>1、请上传企业营业执照（最新的，彩色的）</dd>
                <dd>2、拍照是请确保营业执照边框完整，图像清晰，光线均匀</dd>
            </dl>
            <dl class="uploadtips" v-show="step===3">
                <dt>上传开户许可证 或者 基本存款账户信息</dt>
                <dd>1、请上传企业营业执照（最新的，彩色的）</dd>
                <dd>2、拍照是请确保营业执照边框完整，图像清晰，光线均匀</dd>
            </dl>
            <!-- <button @click="onTest('certPhotoA', 'https://hosjoy-oss-test.oss-cn-hangzhou.aliyuncs.com/images/20200813/25b145c4-3046-453a-98d3-3a67e12ee549.jpg')">正面</button>
            <button @click="onTest('certPhotoB', 'https://hosjoy-oss-test.oss-cn-hangzhou.aliyuncs.com/images/20200915/7656725a-1cea-4236-ab95-7c75ba8eb353.jpg')">反面</button>
            <button @click="onTest('businessLicensePhoto', 'https://hosjoy-oss-test.oss-cn-hangzhou.aliyuncs.com/images/20200813/1fd0bae3-3776-4f96-9664-91e4a889abea.jpg')">营业</button>
            <button @click="onTest('openingPermitPhoto', 'https://hosjoy-oss-test.oss-cn-hangzhou.aliyuncs.com/images/20201118/4614ebcd-e757-42cf-9c74-3f8467f77659.jpg')">开户</button> -->
            <div class="uploadarea" v-show="step===1">
                <div class="cert certPhotoA">
                    <span>身份证人像面照片</span>
                    <input :class="certPhotoA?'lowZIndex':''" type="file" accept="image/*" id="upload" name="upload" @click="getPhoto($event, 'certPhotoA')">
                    <img :src="certPhotoA?certPhotoA:defCertPhotoAUrl" preview="2" preview-text="身份证正面" style="posttion: relative;z-index:10">
                </div>
                <div class="cert certPhotoB">
                    <span>身份证国徽面照片</span>
                    <input :class="certPhotoB?'lowZIndex':''" type="file" accept="image/*" id="upload" name="upload" @click="getPhoto($event, 'certPhotoB')">
                    <img :src="certPhotoB?certPhotoB:defCertPhotoBUrl" preview="2" preview-text="身份证正面" style="posttion: relative;z-index:10">
                </div>
            </div>
            <div class="uploadarea"  v-show="step===2">
                <div class="cert license">
                    <span>营业执照照片</span>
                    <input :class="businessLicensePhoto?'lowZIndex':''" type="file" accept="image/*" id="upload" name="upload" @click="getPhoto($event, 'businessLicensePhoto')">
                    <img :src="businessLicensePhoto?businessLicensePhoto:defLicensePhotoUrl" preview="1" preview-text="营业执照照片" style="posttion: relative;z-index:10">
                </div>
            </div>
            <div class="uploadarea"  v-show="step===3">
                <div class="cert bus">
                    <span>开户许可证或者基本存款账户信息</span>
                    <input :class="openingPermitPhoto?'lowZIndex':''" type="file" accept="image/*" id="upload" name="upload" @click="getPhoto($event, 'openingPermitPhoto')">
                    <img :src="openingPermitPhoto?openingPermitPhoto:defBusPhotoUrl" preview="1" preview-text="开户许可证或者基本存款账户信息" style="posttion: relative;z-index:10">
                </div>
            </div>
            <div class="card f28 bgFFFFFF info" v-show="stepV===1">
                <van-field
                        v-model="bankInfo.userName"
                        required
                        maxlength = '50'
                        label="持卡人"
                        placeholder="请输入持卡人"
                        readonly
                />
                <van-field
                        v-model="bankInfo.bankAccountNumber"
                        type="tel"
                        required
                        maxlength = '30'
                        label="持卡人储蓄卡号"
                        placeholder="请输入持卡人储蓄卡号"
                />
            </div>

            <div class="card f28 bgFFFFFF info" v-show="stepV===2">
                <BankInfo
                    ref="banks"
                    :bankInfo='bankInfo'
                    :userType='userType'
                    @bankSearch='bankSearch'
                    @bankClick='getBankVal'
                />
                <van-checkbox v-model="checked" shape="square" v-show="!bankShow" label-disabled>
                    <span @click="popupVisible = true">同意协议</span>
                </van-checkbox>
            </div>
            <div class="card f28 bgFFFFFF info"  v-show="step===4">
                <BankInfo
                    ref="banks"
                    :bankInfo='bankInfo'
                    :corporationInfo='corporationInfo'
                    :userType='userType'
                    @bankSearch='bankSearch'
                    @bankClick='getBankVal'
                />
                <van-checkbox v-model="checked" shape="square" v-show="!bankShow"  label-disabled>
                    <span @click="popupVisible = true">同意协议</span>
                </van-checkbox>
            </div>
        </div>
        <div class="foot" v-show="!bankShow">
            <div class="btn" :class="{'btnDisble': !checked && stepShow}" @click="submit">{{step===3 ? '确认' : (step===2 ||stepV === 1) ? '下一步' : '提交'}}</div>
        </div>
        <Protocol :visible.sync='popupVisible'></Protocol>
    </div>
</template>
<script>
import Header from '../../common/header'
import Protocol from './protocol'
import { getOcrFromOpen, getOcrFromBL, getOcrFromID } from '../../b2b/api/api.js'
import { postOpen } from '../api/payment'
import { mapMutations, mapGetters } from 'vuex'
import { versions } from '../../common/version'
import BankInfo from './component/bankInfo'
import { Toast, Dialog } from 'vant'
export default {
    name: 'bank',
    data () {
        return {
            title: '实名开户',
            addressName: '',
            areaData: '',
            checked: true,
            popupVisible: false,
            popupDate: false,
            bankShow: false,
            dateTime: '',
            openAccountInfo: '',
            stepShow: true,
            openStatus: this.$route.query.openStatus || '',
            retailer: {
                managerName: '',
                managerCredentialNumber: '',
                retailerName: ''
            },
            bankInfo: {
                userName: '', // 持卡人
                bankName: '',
                bankType: '储蓄卡',
                bankId: '',
                bankPhoneNumber: '',
                bankAccountNumber: '',
                corporationName: '',
                branchName: ''
            },
            corporationInfo: {
                basicAcctNo: '',
                approvalNo: '',
                authCapital: '99999999999999',
                industryBelongType: '400',
                province: '32',
                city: '320100',
                industry: 'F5165',
                scale: '04',
                businessScope: '电器',
                categoryType: '207',
                allLicenceExpiryDate: '20991231',
                legalPersonContactNumber: '',
                legalPersonEmail: '',
                corEmail: ''
            },
            individual: {
                phoneNumber: '',
                indEmail: ''
            },
            companyCode: '',
            businessLicensePhoto: '',
            certPhotoA: '',
            certPhotoB: '',
            openingPermitPhoto: '', // 开户许可证
            step: '',
            stepV: '',
            userType: parseInt(this.$route.query.userType) || 11,
            defCertPhotoAUrl: require('../../../assets/img/b2b/img_idcard1.png'),
            defCertPhotoBUrl: require('../../../assets/img/b2b/img_idcard2.png'),
            defLicensePhotoUrl: require('../../../assets/img/b2b/img_businesslicense.png'),
            defBusPhotoUrl: require('../../../assets/img/b2b/img_busPhoto.png')
        }
    },
    watch: {
        'corporation.corporationName': {
            handler (newName, oldName) {
                this.corporation.corporationShort = newName
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters(['bankData'])
    },
    methods: {
        ...mapMutations({
            setBankInfo: 'SAVE_BANKINFO'
        }),
        bankSearch (val) {
            this.bankShow = val
        },
        getBankVal (item) {
            this.bankInfo.bankName = item.bankName
            this.bankInfo.bankId = item.bankCode
            this.bankShow = false
        },
        onTest (target, url) {
            this.getOEImgUrl(target, url)
        },
        async submit () {
            if (!this.checked && this.stepShow) {
                Toast('请勾选同意协议')
                return
            }
            const phone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
            if (this.userType * 1 === 11) {
                if (this.stepV === 2) {
                    if (!this.bankInfo.bankName) {
                        Toast('请选择银行')
                        return
                    }
                    if (!this.bankInfo.bankPhoneNumber || !phone.test(this.bankInfo.bankPhoneNumber)) {
                        Toast('请输入预留手机号')
                        return
                    }
                    this.jumpLink()
                } else if (this.stepV === 1) {
                    if (!this.bankInfo.userName) {
                        Toast('请输入持卡人')
                        return
                    }
                    if (!this.bankInfo.bankAccountNumber) {
                        Toast('请输入持卡人储蓄卡号')
                        return false
                    }
                    await this.$store.dispatch('getBankAct', this.bankInfo.bankAccountNumber)
                    const { bankName, bankCardType, bankCode } = this.bankData
                    this.bankInfo.bankName = bankName
                    this.bankInfo.bankId = bankCode
                    if (bankCardType !== 10) {
                        Toast('请填写储蓄卡')
                        return
                    }
                    if (!this.checked) {
                        this.stepShow = true
                    }
                    this.stepV++
                }
            } else if (this.userType * 1 === 12 || this.userType * 1 === 13) {
                if (this.step === 4) {
                    if (!this.corporationInfo.basicAcctNo) {
                        Toast('请输入银行卡号')
                        return
                    }
                    if (!this.bankInfo.bankName) {
                        Toast('请输入银行')
                        return
                    }
                    if (!this.bankInfo.branchName) {
                        Toast('请输入分支行')
                        return
                    }
                    if (!this.corporationInfo.approvalNo) {
                        Toast('请输入企业核准号/基本存款账户编号')
                        return
                    }
                    this.jumpLink()
                } else if (this.step === 3) {
                    if (!this.openingPermitPhoto) {
                        Toast('请上传开户许可证或者基本存款账户信息')
                        return
                    }
                    if (!this.checked) {
                        this.stepShow = true
                    }
                    this.step++
                } else if (this.step === 2) {
                    if (!this.businessLicensePhoto) {
                        Toast('请上传营业执照照片')
                        return
                    }
                    if (+this.openStatus === 40) {
                        this.step = this.step + 2
                    } else {
                        this.step++
                    }
                } else {
                    if (!this.certPhotoA) {
                        Toast('请上传身份证正面')
                        return
                    }
                    if (!this.certPhotoB) {
                        Toast('请上传身份证反面')
                        return
                    }
                    this.title = '实名开户'
                    this.step++
                }
            }
        },
        getPhoto (e, n) {
            e.preventDefault()
            this.onClickGetImg(n)
        },
        onClickGetImg (target) {
            if (versions().ios || versions().iPhone || versions().iPad) {
                window.webkit.messageHandlers.dfxB2b.postMessage({
                    'method': 'callPhoto',
                    'target': target
                })
            } else {
                window.kfxt.callPhoto(target)
            }
        },
        async getOEImgUrl (tag, url) {
            Toast.loading({
                message: '图片上传中...',
                forbidClick: true,
                duration: 0
            })
            this[tag] = url
            if (tag === 'businessLicensePhoto') {
                this.getOcrFromBL(tag, url)
            } else if (tag === 'openingPermitPhoto') {
                this.getOcrFromKH(tag, url)
            } else {
                this.getOcrFromID(tag, url)
            }
        },
        async getOcrFromKH (tag, image) {
            const { data } = await getOcrFromOpen({ image })
            Toast.clear()
            if (this.userType * 1 === 12) {
                this.corporationInfo.basicAcctNo = data.account || ''
                this.corporationInfo.approvalNo = data.code || ''
            }
        },
        async getOcrFromBL (tag, image) {
            const { data } = await getOcrFromBL({ image })
            Toast.clear()
            if (tag === 'businessLicensePhoto' && !data.enterpriseNameCh) {
                this.checkOut(tag)
                return false
            }
        },
        async getOcrFromID (tag, image) {
            const { data } = await getOcrFromID({ image })
            Toast.clear()
            if (tag === 'certPhotoA' && !data.personName) {
                this.checkOut(tag)
                return false
            }
            if (tag === 'certPhotoB' && !data.timeZone) {
                this.checkOut(tag)
                return false
            }
        },
        checkOut (tag, context) {
            Dialog.alert({
                title: '图片识别失败',
                message: tag === 'businessLicensePhoto' ? '请上传清晰的营业照照片，以便于准确识别内容。' : '请上传清晰的身份证照片，以便于准确识别内容。',
                confirmButtonText: '重新上传',
                closeOnClickOverlay: true
            }).then(() => {
                this[tag] = ''
                this.onClickGetImg(tag)
            }).catch(() => {
                this[tag] = ''
            })
        },
        onBack () {
            let _this = this
            if (this.bankShow) {
                this.$refs.banks.bankshow()
                return false
            }
            if ((this.userType * 1 === 11) && (this.stepV !== 1)) {
                this.stepV--
                if (this.stepV < 2 && !this.checked) {
                    this.stepShow = false
                }
                return
            }
            if ((this.userType * 1 === 12) && (this.step !== 1)) {
                if (!this.openStatus && this.step <= 3) {
                    Dialog.confirm({
                        title: '提示',
                        message: '返回后认证流程将中断'
                    }).then(() => {
                        _this.$router.go(-1)
                    })
                    return
                }
                if (this.step >= 3 && +this.openStatus === 40) {
                    this.step = this.step - 2
                } else {
                    this.step--
                }
                if (this.step < 5 && !this.checked) {
                    this.stepShow = false
                }
                return
            }
            Dialog.confirm({
                title: '提示',
                message: '返回后认证流程将中断'
            }).then(() => {
                _this.$router.go(-1)
            })
        },
        async jumpLink () {
            const { companyCode, userType, openingPermitPhoto, certPhotoA, certPhotoB, businessLicensePhoto, bankInfo } = this
            Toast.loading({
                message: '提交中...',
                forbidClick: true,
                duration: 0
            })
            let res = ''
            if (userType * 1 === 11) {
                let individual = {
                    ...this.openAccountInfo,
                    ...this.individual
                }
                res = await postOpen({ individual: { ...individual }, bankAccount: { ...bankInfo }, companyCode, userType })
            } else if (userType * 1 === 12 || userType * 1 === 13) {
                let corporation = {
                    ...this.openAccountInfo,
                    ...this.corporationInfo
                }
                bankInfo.bankAccountNumber = corporation.basicAcctNo
                res = await postOpen({ corporation: { ...corporation, openingPermitPhoto, certPhotoA, certPhotoB, businessLicensePhoto }, bankAccount: { ...bankInfo }, companyCode, userType })
            }
            const { data: { status, failureReason } } = res
            Toast.clear()
            localStorage.removeItem('openAccountInfo')
            this.$router.push({ path: '/b2b/business/openResult', query: { status, userType, errmsg: failureReason, type: '1' } })
        }
    },
    mounted () {
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.openAccountInfo = localStorage.getItem('openAccountInfo') && JSON.parse(localStorage.getItem('openAccountInfo'))
        this.companyCode = userInfo.companyCode
        if (this.userType * 1 === 11) {
            this.stepV = 1
            let indAddress = this.openAccountInfo.indAddress
            this.individual.phoneNumber = userInfo.username
            this.individual.indEmail = `${userInfo.username}@hosjoy.com`
            this.bankInfo.bankProvince = indAddress ? indAddress.split(' ')[0] : ''
            this.bankInfo.bankCity = indAddress || '江苏省南京市'
            this.bankInfo.userName = this.openAccountInfo.userName
            this.bankInfo.bankAccountNumber = this.openAccountInfo.bankAccountNumber || ''
            this.bankInfo.bankPhoneNumber = this.openAccountInfo.bankPhoneNumber || ''
        } else {
            this.step = this.openStatus ? 1 : 3
            let corAddress = this.openAccountInfo.corAddress
            this.corporationInfo.legalPersonContactNumber = userInfo.username
            this.corporationInfo.legalPersonEmail = `${userInfo.username}@hosjoy.com`
            this.corporationInfo.corEmail = `${userInfo.username}@hosjoy.com`
            this.bankInfo.bankProvince = corAddress ? corAddress.split(' ')[0] : ''
            this.bankInfo.bankCity = corAddress || '江苏省南京市'
            this.bankInfo.corporationName = this.openAccountInfo.corporationName || ''
            this.openingPermitPhoto = this.openAccountInfo.openingPermitPhoto || ''
            this.certPhotoA = this.openAccountInfo.certPhotoA || ''
            this.certPhotoB = this.openAccountInfo.certPhotoB || ''
            this.businessLicensePhoto = this.openAccountInfo.businessLicensePhoto || ''
            this.corporationInfo.basicAcctNo = this.openAccountInfo.basicAcctNo || ''
            this.corporationInfo.approvalNo = this.openAccountInfo.approvalNo || ''
            this.bankInfo.bankId = this.openAccountInfo.bankId || ''
            this.bankInfo.bankName = this.openAccountInfo.bankName || ''
            this.bankInfo.branchName = this.openAccountInfo.branchName || ''
        }
        window.getOEImgUrl = (tag, url) => {
            this.getOEImgUrl(tag, url)
        }
    },
    components: {
        Header,
        Protocol,
        BankInfo
    }
}
</script>
<style lang="scss" scoped>
    .business{
        height: 100%;

    }
    .foot {
        padding: 32px;
        font-size: 28px;
        .btn {
            width: 100%;
            height: 96px;
            line-height: 96px;
            border-radius: 96px;
            background: #ff7a45;
            color: #ffffff;
            text-align: center;
            cursor: pointer;
        }
        .btnDisble {
            background: #cccccc;
        }
        .xy {
            text-align: center;
            margin-top: 20px;
            margin-bottom: 26px;
            color: #999999;
            span {
                color: #ff7a45;
            }
        }
    }
    .content {
        background: #ffffff;
        .uploadtips{
            padding: 32px;
            dt{
                color: #000;
                font-size: 36px;
                margin-bottom: 16px;
            }
            dd{
                font-size: 24px;
                color: #999;
            }
        }
        .uploadarea{
            padding: 32px;
            .cert{
                position: relative;
                width: 686px;
                span{
                    color: #666;
                    font-size: 26px;
                    display: block;
                    margin-bottom: 15px;
                }
                input{
                    position: absolute;
                    width: 686px;
                    height: 386px;
                    opacity: 0;
                }
                img{
                    width: 686px;
                    height: 386px;
                }
            }
            .certPhotoB{
                margin-top: 48px;
            }
            .license{
                input{
                    height: 514px;
                }
                img{
                    height: 514px;
                }
            }
            .bus {
                input{
                    height: 914px;
                }
                img{
                    height: 914px;
                }
            }
        }
        .card {
            margin-bottom: 20px;
            .item {
                position: relative;
                display: flex;
                justify-content: space-between;
                padding: 32px;
                .item-left {
                    position: relative;
                    .positionRight {
                        line-height: 0;
                        position: absolute;
                        top: calc(50% - 16px);
                        right: -40px;
                        width: 32px;
                        height: 32px;
                    }
                    .BankTips::before {
                        content: "";
                        position: absolute;
                        bottom: -20px;
                        left: 123px;
                        display: inline-block;
                        width: 0;
                        height: 0;
                        border: 10px solid;
                        border-color: #ff7a45 transparent transparent;
                    }
                    .BankTips {
                        padding: 10px;
                        position: absolute;
                        width: 336px;
                        height: 50px;
                        line-height: 50px;
                        left: 0;
                        bottom: 80px;
                        color: #333333;
                        border: 2px solid #ff7a45;
                        background-color: #fff9f5;
                    }
                }
                .item-right {
                    position: relative;
                    &.paddingRight60 {
                        padding-right: 60px;
                    }
                    &.paddingRight210 {
                        padding-right: 210px;
                    }
                    .edit {
                        line-height: 0;
                        position: absolute;
                        right: 0;
                        top: calc(50% - 19px);
                        width: 40px;
                        height: 40px;
                        z-index: 2;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .code {
                        position: absolute;
                        text-align: center;
                        right: 0;
                        top: calc(50% - 19px);
                        width: 190px;
                        height: 40px;
                        border-radius: 10px;
                    }
                    .verCode {
                        background-color: #ff7a45;
                        color: #ffffff;
                    }
                    .disverCode {
                        background-color: #999999;
                        color: #ffffff;
                    }
                    input[type="text"] {
                        text-align: right;
                    }
                    .delete {
                        background-image: url("../../../assets/img/b2b/icon-delete.png");
                        background-repeat: no-repeat;
                        background-size: cover;
                        position: absolute;
                        width: 40px;
                        height: 40px;
                        top: -20px;
                        left: -20px;
                    }
                    .arrow {
                        position: relative;
                    }
                }
                &.borderBot::before {
                    width: auto;
                }
                &.itemPic {
                    padding: 32px;
                    .item-right {
                        position: relative;
                        padding-right: 0;
                        input {
                            position: absolute;
                            right: 0;
                            top: 0;
                            width: 128px;
                            height: 128px;
                            border: none;
                            opacity: 0;
                        }
                        .lowZIndex {
                            z-index: -1;
                        }
                        img {
                            display: block;
                            width: 128px;
                            height: 128px;
                        }
                    }
                }
                &.morePic {
                    .item-right {
                        .item-flex {
                            width: 288px;
                            margin-bottom: 32px;
                            display: flex;
                            justify-content: space-between;
                            .container {
                                position: relative;
                            }
                        }
                    }
                }
            }
            .flex {
                display: flex;
                justify-content: space-around;
            }
        }
        .info{
            background: #ffffff;
            padding-left: 32px;
            font-size: 28px;
        }
    }
    .van-checkbox {
        padding: 24px 0;
    }
    /deep/ .van-checkbox__label {
        line-height: inherit;
        font-size: 24px;
        margin-left: 20px;
        span{
            text-decoration: underline;
        }
    }
    /deep/ .van-checkbox__icon {
        font-size: 24px;
    }
    /deep/ .van-checkbox__icon .van-icon{
        font-size: 24px;
    }
    /deep/ .van-cell{
        align-items: center;
    }
    /deep/ .van-button--normal {
        width: 100%;
        height: 96px;
        line-height: 96px;
        font-size: 32px;
    }
    /deep/ .van-button--default{
        border: 2px solid rgb(255, 122, 69);
    }
    /deep/ .van-icon-question-o:before{
        content: "\F00A";
    }
    /deep/ .van-field__right-icon {
        margin: 0 20px;
    }
    /deep/ .van-field__label{
        height: auto;
    }
</style>